// -----------------------------------------------------------------------------
// Constants
// -----------------------------------------------------------------------------

export const NAME = 'dfbDropdown'
const CLASS = 'dfb-Dropdown'
const EVENT_KEY = `${NAME}:`

export const ClassName = {
  ROOT: CLASS,
  SELECT: `${CLASS}-select`,
  LABEL: `${CLASS}-label`,
  COMBOBOX: `${CLASS}-combobox`,
  VALUE: `${CLASS}-value`,
  TOGGLE: `${CLASS}-toggle`,
  LISTBOX: `${CLASS}-listbox`,
  ITEM: `${CLASS}-item`,
  OPTION: `${CLASS}-option`,
  OPTIONLABEL: `${CLASS}-optionLabel`,
  INPUT: `${CLASS}-input`
}

export const States = {
  OPEN: 'is-open',
  INVALID: 'is-invalid'
}

export const Selector = {
  ROOT: `.${ClassName.ROOT}`,
  SELECT: `.${ClassName.SELECT}`,
  LABEL: `.${ClassName.LABEL}`,
  COMBOBOX: `.${ClassName.COMBOBOX}`,
  VALUE: `.${ClassName.VALUE}`,
  TOGGLE: `.${ClassName.TOGGLE}`,
  LISTBOX: `.${ClassName.LISTBOX}`,
  ITEM: `.${ClassName.ITEM}`,
  ITEM_ENABLED: `.${ClassName.ITEM}:not([aria-disabled])`,
  OPTION: `.${ClassName.OPTION}`,
  OPTIONLABEL: `.${ClassName.OPTIONLABEL}`,
  INPUT: `.${ClassName.INPUT}`,
  SELECTED: '[aria-selected="true"]',
  UNSELECTED: '[aria-selected="false"]',
  DISABLED: '[aria-disabled]',
  MULTISELECTABLE: `[aria-multiselectable]`,
  COUNT_CHECKED: `[data-count-checked]`
}

export const Event = {
  CLICK: `click`,
  OPEN: `${EVENT_KEY}open`,
  CLOSE: `${EVENT_KEY}close`,
  CHANGE: `${EVENT_KEY}change`,
  INPUT_CHANGE: `change`
}

export const OptionValueAttributes = ['data-value', 'value']

export const OptionValueSelectorOrder = [
  'data-value',
  'value',
  { selector: Selector.OPTION, attribute: 'value' }
]

export const OptionCheckedSelectorOrder = ['input:checked']
